import { createContext, useContext } from "react";

import {
  CURRENT_ENTITLEMENT_STATE,
  type EntitlementState,
  type PaidFeatureId,
  isPaidFeatureUnlocked,
} from "./paid-features";

const EntitlementContext = createContext<EntitlementState>(CURRENT_ENTITLEMENT_STATE);

declare global {
  interface Window {
    __INVOICE_BUILDER_E2E_ENTITLEMENT__?: EntitlementState;
  }
}

export function initialEntitlementStateForRuntime(): EntitlementState {
  if (
    import.meta.env.DEV &&
    typeof window !== "undefined" &&
    window.location.hostname === "127.0.0.1" &&
    window.__INVOICE_BUILDER_E2E_ENTITLEMENT__
  ) {
    return window.__INVOICE_BUILDER_E2E_ENTITLEMENT__;
  }
  return CURRENT_ENTITLEMENT_STATE;
}

export function EntitlementProvider({
  value = initialEntitlementStateForRuntime(),
  children,
}: {
  value?: EntitlementState;
  children: React.ReactNode;
}) {
  return <EntitlementContext.Provider value={value}>{children}</EntitlementContext.Provider>;
}

export function useEntitlementState(): EntitlementState {
  return useContext(EntitlementContext);
}

export function usePaidFeatureAccess(id: PaidFeatureId): boolean {
  return isPaidFeatureUnlocked(id, useEntitlementState());
}
